// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"49":"b67d7c13","157":"2c63c200","212":"0c35cd30","378":"c43f0d88","429":"f2c7043c","453":"dcbcf548","468":"8010b6ac","530":"c088b74a","538":"fa163fcf","591":"2efaadd0","613":"83957ce9","627":"4a39f75f","628":"1da2d963","762":"63e0a0aa","778":"f20ae4ca","956":"21c33566"}[chunkId] + ".chunk.js";
};